import React from 'react';
import './Pricing.css'; // Add styles for the Pricing page

function Pricing() {
  return (
    <div className="pricing-container">
      <h1 className="pricing-header">Pricing</h1>
      <p className="pricing-description">
        Our event management software is free for existing customers of our business. Non-customers can access the software for a one-time event fee.
      </p>
      <div className="pricing-tiers">
        <div className="pricing-tier">
          <h2 className='stile'>Small Events</h2>
          <p>Up to 50 attendees</p>
          <p><strong>$50–$100</strong> per event</p>
        </div>
        <div className="pricing-tier">
          <h2 className='stile'>Medium Events</h2>
          <p>50–200 attendees</p>
          <p><strong>$150–$250</strong> per event</p>
          <p>Optional on-site support from a K&M Sales staff member</p>
        </div>
        <div className="pricing-tier">
          <h2 className='stile'>Large Events</h2>
          <p>200+ attendees</p>
          <p><strong>$300–$500</strong> per event</p>
          <p>Optional on-site support from a K&M Sales staff member</p>
        </div>
      </div>
      <h3 className="pricing-note">
  Contact us <a href="mailto:skhan139@icloud.com" className="email-link">here</a> for custom pricing for large-scale events or subscription options!.
</h3>
    </div>
  );
}

export default Pricing;